import {
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    BymoPagePropsSpecialContentSettingMetadata
} from '../../client-server-common';
import {WixMediaResource} from '@wix/devzai-common-wix';
import {
    DoppeCheckoutActionSettings,
    getDefaultDoppeCheckoutSettingsForAction,
    prepareCheckoutSettingsForViewer
} from '../../client-server-common/types/doppe-checkout-action-settings';
import {DoppeActionPrice} from '../../client-server-common/types/doppe-action-price';
import {RichTextContent} from '@wix/devzai-utils-react';
import {
    DoppeAutomationTriggers,
    DoppeHideableValue,
    doppeHideableValueCreateHidden,
    doppePremiumFeatureIsDisabled,
    DoppePremiumFeatures,
} from '../../client-server-common';

export namespace DoppeActionTypeRequest {

    export interface RequestOption {
        title: string;
        description: DoppeHideableValue<RichTextContent>;
        priceData: DoppeActionPrice;
        images: WixMediaResource[] | null;
        fulfillmentDetails: DoppeHideableValue<RichTextContent>;
        requestsInstructions: DoppeHideableValue<RichTextContent>;
        previewCheckoutButtonText: DoppeHideableValue<string>;
        showNotesInput: boolean;
        ribbon: DoppeHideableValue<string>;
        id: string;
    }

    export interface ActionSettings extends
        RequestOption,
        DoppeCheckoutActionSettings {
        previewCheckoutButtonText: string,
    }

}


export const doppeActionTypeRequest = doppeActionTypeDefineMetadata<DoppeActionTypeRequest.ActionSettings>({
    id: 'co.hopp.action/request-item',
    resolveActionSettings: action => {

        const {
            checkoutSettings,
            ...restSettings
        } = action.settings;


        return {
            id: '',
            title: '',
            description: doppeHideableValueCreateHidden(''),
            priceData: {
                actualPrice: 0,
                currencyCode: 'USD',
            },
            images: null,
            showNotesInput: true,
            requestsInstructions: doppeHideableValueCreateHidden(''),
            fulfillmentDetails: doppeHideableValueCreateHidden(''),
            previewCheckoutButtonText: 'Checkout',
            ribbon: doppeHideableValueCreateHidden('SALE'),
            ...restSettings,
            checkoutSettings: getDefaultDoppeCheckoutSettingsForAction(checkoutSettings)
        }
    },
    prepareForViewer: actionSettings => {
        prepareCheckoutSettingsForViewer(actionSettings);
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            id: BymoPagePropsSpecialContentSettingMetadata.Unknown,
            title: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityTitle),
            description: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
            images: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.MultipleMedia, BymoPagePropsContentSettingSemanticMeaning.EntityMedia),
            fulfillmentDetails: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            requestsInstructions: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            previewCheckoutButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText),
            ribbon: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityRibbon)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    isPaymentAction: true,
    getSupportedAutomationTrigger: () => DoppeAutomationTriggers.PaymentReceived,
    isFormAction: false,
    isPremiumAction: (premiumFeaturesStatus) => {
        return doppePremiumFeatureIsDisabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_monetization_actions)
    },
});
